import axios, { AxiosStatic } from 'axios';

import combineApiURL from 'utils/combineApiURL';

const getHeaders = () => {
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    auth: localStorage.getItem('token'),
    token: localStorage.getItem('token'),
  };
};

const instance = axios.create({
  baseURL: combineApiURL(),
  headers: getHeaders(),
});

(instance as AxiosStatic).CancelToken = axios.CancelToken;
(instance as AxiosStatic).isCancel = axios.isCancel;

export default instance as AxiosStatic;
